/**
 * Cette fonction sert à drastiquement réduire le temps de chargement des pages en évitant de charger tous les scripts d'un iframe Youtube au chargement de la page mais en les chargeant seulement quand la vidéo est cliquée.
 * * Source : https://www.labnol.org/internet/light-youtube-embeds/27941/
 */

/*
 * Le player en front doit ressembler à ça
 * <div class="youtube-player" data-id="YOUTUBE_ID_VIDEO" />
 */

function embedYTVideos() {
    document.addEventListener('DOMContentLoaded', function() {
        var div,
            n,
            v = document.getElementsByClassName('youtube-player');
        for (n = 0; n < v.length; n++) {
            div = document.createElement('div');
            div.setAttribute('id', 'video_' + v[n].dataset.id);
            div.setAttribute('data-id', v[n].dataset.id);
            div.setAttribute('data-urlparams', v[n].dataset.urlparams);
            div.innerHTML = labnolThumb(v[n].dataset);
            div.onclick = labnolIframe;
            v[n].appendChild(div);
        }
    });

    function labnolThumb(data) {
        if ( data.img ) {
            var thumb = '<img src="' + data.img + '">',
                play = '<div class="play"></div>';

            return thumb + play;
        }
        else {
            var thumb = '<img src="https://i.ytimg.com/vi/ID/maxresdefault.jpg">',
                play = '<div class="play"></div>';

            return thumb.replace('ID', data.id) + play;
        }

        return '';
    }

    function labnolIframe() {
        var youtube_id = this.dataset.id;

        var container = document.createElement('div');
        container.setAttribute('class', 'video-container');

        var iframe = document.createElement('iframe');
        var embed = 'https://www.youtube.com/embed/ID?autoplay=1';
        var url = embed.replace('ID', youtube_id);

        var urlParams = this.dataset.urlparams;

        if (urlParams) {
            url = url + '&' + urlParams;
        }

        iframe.setAttribute('id', 'video_' + youtube_id);
        iframe.setAttribute('src', url);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '1');
        iframe.setAttribute('allow', 'autoplay');
        iframe.setAttribute('rel', '0');
        iframe.setAttribute('loop', '1');
        iframe.setAttribute('showinfo', '0');
        iframe.setAttribute('modestbranding', '1');
        iframe.setAttribute('autoplay', '0');

        //this.parentNode.replaceChild(iframe, this);
        container.appendChild(iframe);
        this.parentNode.replaceChild(container, this);


        jQuery('.youtube-player').append('<div class="video-overlay"></div>');
    }

    jQuery(document).ready(function($) {
        function resizeIframes()
        {
            $('.wrapper-content iframe').each(function() {
                var height = parseFloat($(this).attr('height'));
                var width = parseFloat($(this).attr('width'));

                var max_width = $(this).parent().width();

                var new_height = max_width * height / width;

                $(this).css('height', new_height + 'px');
            });
        }

        $(window).resize(function() {
            resizeIframes();
        });
    });
}

export { embedYTVideos };
